import { render, staticRenderFns } from "./TolRoute.vue?vue&type=template&id=73e93a88&scoped=true"
import script from "./TolRoute.vue?vue&type=script&lang=js"
export * from "./TolRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e93a88",
  null
  
)

export default component.exports